<p-dialog header="{{ editMode ? 'Edit Customs Clearance Charge' : 'Add Customs Clearance Charge' }}"
    [(visible)]="visible" [style]="{width: '70vw'}" [modal]="true" [draggable]="false" [resizable]="false"
    (onHide)="closeDialog()">
    @if (isLoading) {
    <p-progressBar mode="indeterminate" class="m-2"></p-progressBar>
    } @else {
    <form [formGroup]="chargeForm" (ngSubmit)="saveCharge()" class="mt-3">
        <div class="p-fluid">
            <!-- Service Details Fieldset -->
            <div class="flex m-4">
                <p-fieldset legend="Service Details" [toggleable]="true" class="w-full" styleClass="surface-ground">
                    <div class="formgrid grid">
                        <div class="field col-12 md:col-6">
                            <p-inputGroup>
                                <p-inputGroupAddon><i class="pi pi-database"></i></p-inputGroupAddon>
                                <p-iftaLabel>
                                    <p-select id="sourceMode" [options]="sourceModes" formControlName="sourceMode"
                                        optionLabel="label" optionValue="value" styleClass="w-full"></p-select>
                                    <label for="sourceMode">Charge Source</label>
                                </p-iftaLabel>
                            </p-inputGroup>
                        </div>
                        <div class="field col-12 md:col-6">
                            <p-inputGroup>
                                <p-inputGroupAddon><i class="pi pi-hashtag"></i></p-inputGroupAddon>
                                <p-iftaLabel>
                                    <input id="lineNumber" type="number" pInputText formControlName="lineNumber"
                                        [readonly]="true" />
                                    <label for="lineNumber">Line Number</label>
                                </p-iftaLabel>
                            </p-inputGroup>
                        </div>
                        @if (chargeForm.get('sourceMode')?.value === 'PRODUCT') {
                        <div class="field col-12 md:col-6">
                            <p-inputGroup>
                                <p-inputGroupAddon><i class="pi pi-box"></i></p-inputGroupAddon>
                                <p-iftaLabel>
                                    <p-select id="productId" [options]="logisticsProducts" formControlName="productId"
                                        optionLabel="name" optionValue="productID" [filter]="true"
                                        filterBy="name,productCode" appendTo="body" styleClass="w-full"></p-select>
                                    <label for="productId">Catalog Service *</label>
                                </p-iftaLabel>
                            </p-inputGroup>
                            @if (chargeForm.get('productId')?.invalid && chargeForm.get('productId')?.touched) {
                            <small class="p-error">Catalog service is required.</small>
                            }
                        </div>
                        <div class="field col-12 md:col-6">
                            <p-inputGroup>
                                <p-inputGroupAddon><i class="pi pi-sitemap"></i></p-inputGroupAddon>
                                <p-iftaLabel>
                                    <p-select id="productVariantId" [options]="productVariants()"
                                        formControlName="productVariantId" optionLabel="name" optionValue="variantID"
                                        [showClear]="true" appendTo="body" styleClass="w-full"></p-select>
                                    <label for="productVariantId">Catalog Variant</label>
                                </p-iftaLabel>
                            </p-inputGroup>
                        </div>
                        @if (selectedProduct(); as product) {
                        <div class="field col-12">
                            <div class="surface-50 border-1 surface-border border-round p-3 text-sm">
                                <strong>{{ product.productCode }}</strong>
                                <span class="mx-2">|</span>
                                <span>{{ product.currencyCode }}</span>
                                <span class="mx-2">|</span>
                                <span>Tax {{ product.taxRate || 0 }}%</span>
                                <span class="mx-2">|</span>
                                <span>Income account {{ product.incomeAccountName || 'company default' }}</span>
                                <span class="mx-2">|</span>
                                <span>Expense account {{ product.expenseAccountName || 'company default' }}</span>
                            </div>
                        </div>
                        }
                        } @else {
                        <div class="field col-12 md:col-6">
                            <p-inputGroup>
                                <p-inputGroupAddon><i class="pi pi-cog"></i></p-inputGroupAddon>
                                <p-iftaLabel>
                                    <p-select id="service" [options]="services" formControlName="service"
                                        optionLabel="label" [filter]="true" styleClass="w-full"></p-select>
                                    <label for="service">Service</label>
                                </p-iftaLabel>
                            </p-inputGroup>
                            @if (chargeForm.get('service')?.invalid && chargeForm.get('service')?.touched) {
                            <small class="p-error">Service is required.</small>
                            }
                        </div>
                        <div class="field col-12 md:col-6">
                            <p-inputGroup>
                                <p-inputGroupAddon><i class="pi pi-tags"></i></p-inputGroupAddon>
                                <p-iftaLabel>
                                    <p-select id="variant" [options]="variants" formControlName="variant"
                                        optionLabel="label" [filter]="true" styleClass="w-full"></p-select>
                                    <label for="variant">Variant</label>
                                </p-iftaLabel>
                            </p-inputGroup>
                        </div>
                        }
                        <div class="field col-12 md:col-6">
                            <p-inputGroup>
                                <p-inputGroupAddon><i class="pi pi-align-left"></i></p-inputGroupAddon>
                                <p-iftaLabel>
                                    <input id="description" type="text" pInputText formControlName="description" />
                                    <label for="description">Description</label>
                                </p-iftaLabel>
                            </p-inputGroup>
                        </div>
                    </div>
                </p-fieldset>
            </div>

            <!-- Calculation Details Fieldset -->
            <div class="flex m-4">
                <p-fieldset legend="Calculation" [toggleable]="true" class="w-full" styleClass="surface-ground">
                    <div class="formgrid grid">
                        <div class="field col-12 md:col-4">
                            <p-inputGroup>
                                <p-inputGroupAddon><i class="pi pi-calculator"></i></p-inputGroupAddon>
                                <p-iftaLabel>
                                    <p-inputNumber id="quantity" formControlName="quantity"
                                        styleClass="w-full"></p-inputNumber>
                                    <label for="quantity">Quantity</label>
                                </p-iftaLabel>
                            </p-inputGroup>
                            @if (chargeForm.get('quantity')?.invalid && chargeForm.get('quantity')?.touched) {
                            <small class="p-error">Quantity is required.</small>
                            }
                        </div>
                        <div class="field col-12 md:col-4">
                            <p-inputGroup>
                                <p-inputGroupAddon><i class="pi pi-dollar"></i></p-inputGroupAddon>
                                <p-iftaLabel>
                                    <p-inputNumber id="rate" formControlName="rate" mode="currency" currency="SAR"
                                        styleClass="w-full"></p-inputNumber>
                                    <label for="rate">Rate</label>
                                </p-iftaLabel>
                            </p-inputGroup>
                            @if (chargeForm.get('rate')?.invalid && chargeForm.get('rate')?.touched) {
                            <small class="p-error">Rate is required.</small>
                            }
                        </div>
                        <div class="field col-12 md:col-4">
                            <p-inputGroup>
                                <p-inputGroupAddon><i class="pi pi-wallet"></i></p-inputGroupAddon>
                                <p-iftaLabel>
                                    <p-inputNumber id="amount" formControlName="amount" mode="currency" currency="SAR"
                                        styleClass="w-full"></p-inputNumber>
                                    <label for="amount">Amount</label>
                                </p-iftaLabel>
                            </p-inputGroup>
                            @if (chargeForm.get('amount')?.invalid && chargeForm.get('amount')?.touched) {
                            <small class="p-error">Amount is required.</small>
                            }
                        </div>
                    </div>
                </p-fieldset>
            </div>

            <!-- Financials Fieldset -->
            <div class="flex m-4">
                <p-fieldset legend="Financials & VAT" [toggleable]="true" class="w-full" styleClass="surface-ground">
                    <div class="formgrid grid">
                        <div class="field col-12 md:col-6">
                            <p-inputGroup>
                                <p-inputGroupAddon><i class="pi pi-percentage"></i></p-inputGroupAddon>
                                <p-iftaLabel>
                                    <p-inputNumber id="vat_percentage" formControlName="vat_percentage" suffix="%"
                                        styleClass="w-full"></p-inputNumber>
                                    <label for="vat_percentage">VAT Percentage</label>
                                </p-iftaLabel>
                            </p-inputGroup>
                        </div>
                        <div class="field col-12 md:col-6">
                            <p-inputGroup>
                                <p-inputGroupAddon><i class="pi pi-money-bill"></i></p-inputGroupAddon>
                                <p-iftaLabel>
                                    <p-inputNumber id="vat_amount" formControlName="vat_amount" mode="currency"
                                        currency="SAR" styleClass="w-full"></p-inputNumber>
                                    <label for="vat_amount">VAT Amount</label>
                                </p-iftaLabel>
                            </p-inputGroup>
                        </div>
                        <div class="field col-12 md:col-6">
                            <p-inputGroup>
                                <p-inputGroupAddon><i class="pi pi-chart-bar"></i></p-inputGroupAddon>
                                <p-iftaLabel>
                                    <p-inputNumber id="totalAmount" formControlName="totalAmount" mode="currency"
                                        currency="SAR" styleClass="w-full"></p-inputNumber>
                                    <label for="totalAmount">Total Amount</label>
                                </p-iftaLabel>
                            </p-inputGroup>
                        </div>
                        <div class="field col-12 md:col-6">
                            <p-inputGroup>
                                <p-inputGroupAddon><i class="pi pi-building"></i></p-inputGroupAddon>
                                <p-iftaLabel>
                                    <p-select id="billTo" [options]="companies" formControlName="billTo"
                                        optionLabel="name" [filter]="true" styleClass="w-full"></p-select>
                                    <label for="billTo">Bill To</label>
                                </p-iftaLabel>
                            </p-inputGroup>
                            @if (chargeForm.get('billTo')?.invalid && chargeForm.get('billTo')?.touched) {
                            <small class="p-error">Bill To is required.</small>
                            }
                        </div>
                    </div>
                </p-fieldset>
            </div>

            <!-- Costing Fieldset -->
            <div class="flex m-4">
                <p-fieldset legend="Costing" [toggleable]="true" class="w-full" styleClass="surface-ground">
                    <div class="formgrid grid">
                        <div class="field col-12 md:col-6">
                            <p-inputGroup>
                                <p-inputGroupAddon><i class="pi pi-arrow-down"></i></p-inputGroupAddon>
                                <p-iftaLabel>
                                    <p-inputNumber id="buyingAmount" formControlName="buyingAmount" mode="currency"
                                        currency="SAR" styleClass="w-full"></p-inputNumber>
                                    <label for="buyingAmount">Buying Amount</label>
                                </p-iftaLabel>
                            </p-inputGroup>
                        </div>
                        <div class="field col-12 md:col-6">
                            <p-inputGroup>
                                <p-inputGroupAddon><i class="pi pi-arrow-up"></i></p-inputGroupAddon>
                                <p-iftaLabel>
                                    <p-inputNumber id="sellingAmount" formControlName="sellingAmount" mode="currency"
                                        currency="SAR" styleClass="w-full"></p-inputNumber>
                                    <label for="sellingAmount">Selling Amount</label>
                                </p-iftaLabel>
                            </p-inputGroup>
                        </div>
                    </div>
                </p-fieldset>
            </div>
        </div>
    </form>
    }
    <ng-template pTemplate="footer">
        <p-button label="Cancel" icon="pi pi-times" (click)="closeDialog()" styleClass="p-button-text"></p-button>
        <p-button label="Save" icon="pi pi-check" (click)="saveCharge()" [loading]="isLoading"
            [disabled]="chargeForm.invalid"></p-button>
    </ng-template>
</p-dialog>
